import React, { useEffect, useState } from "react";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserManagement = () => {
  const [users, setUsers] = useState([]);

  // ===== FETCH USERS (POST) =====
  const fetchUsers = async () => {
    try {
      const res = await fetch(getApiUrl("user-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}), // POST — as you wanted
      });

      const data = await res.json();

      if (data.success) {
        setUsers(data.data);
      } else {
        toast.error(data.message || "Failed to load users");
      }
    } catch (error) {
      toast.error("Server error — try again.");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // ===== VIEW ONLY =====
  const handleView = (row) => {
    alert(`
Name: ${row.name || "-"}
Phone: ${row.phone || "-"}
Email: ${row.email || "-"}
User Type: ${row.userType}
    `);

    // (Later we can open a modal with full details)
  };

  // ===== TABLE COLUMNS =====
  const columns = [
    { name: "Name", selector: (row) => row.name || "-" },
    { name: "Phone", selector: (row) => row.phone || "-" },
    { name: "Email", selector: (row) => row.email || "-" },
    { name: "Type", selector: (row) => row.userType },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-info btn-sm"
          onClick={() => handleView(row)}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <ToastContainer />

      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">User Management</h3>
      </div>

      <ReusableTable columns={columns} data={users} title="User List" />
    </div>
  );
};

export default UserManagement;
